import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSession } from "../../../../hooks";
import { useEditBlock } from "../../../../http";
import { IBlock } from "../../../../models";
import { CreateEditBlockForm, ICreateEditBlockFormState } from "./CreateEditBlockForm";
import { usePlanContext } from "./PlanContext";

interface IProps {
  visible: boolean;
  block: IBlock;
  onSaved: () => void;
  onCancelled: () => void;
}

const EditBlockModal = (props: IProps) => {
  const { planGuid } = usePlanContext();
  const { userId } = useSession();
  const { mutate, isLoading: isSaving } = useEditBlock();
  const { formState, control, handleSubmit, reset } = useForm<ICreateEditBlockFormState>({
    defaultValues: {
      name: props.block.name,
      hintText: props.block.hintText,
    },
  });

  useEffect(() => {
    reset({
      name: props.block.name,
      hintText: props.block.hintText,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.block]);

  async function handleSaveClicked() {
    handleSubmit((data) => {
      mutate(
        {
          planGuid: planGuid,
          guid: props.block.guid,
          name: data.name,
          hintText: data.hintText,
          sortOrder: props.block.sortOrder,
          modifiedByUserId: userId,
        },
        {
          onSuccess: () => {
            props.onSaved();
          },
        }
      );
    })();
  }

  function handleClose(_event: object, reason: "backdropClick" | "escapeKeyDown") {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    handleCancelClicked();
  }

  function handleCancelClicked() {
    reset(undefined, { keepDefaultValues: true });
    props.onCancelled();
  }

  return (
    <Dialog open={props.visible} onClose={handleClose}>
      <DialogTitle>Edit Block</DialogTitle>
      <DialogContent>
        <CreateEditBlockForm formState={formState} control={control} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={isSaving} onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isSaving}
          endIcon={isSaving ? <CircularProgress size={20} sx={{ color: "grey.400" }} /> : null}
          onClick={handleSaveClicked}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { EditBlockModal };
